import React from 'react';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Copyright BMS Cloud &copy; 2020. All rights reserved.</span>
        
      </footer>
    );
  }
;

export default Footer;
